export let SERVER_URL = 'https://backend.goldrh.com.co/api/';
//export let SERVER_URL = 'http://comprobantes_backend.goldrh.com.co/api/';
//export let SERVER_URL = 'http://localhost/Safetech/gold_rh/public/api/';